import {
  BottomSheet,
  Checkbox,
  DialogFooter,
  Illustration,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { Box, FormControlLabel, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useState } from "react";
import { Link } from "react-router-dom";

import { Button } from "../components/Button";

interface ClockOutChartingReminderProps {
  modalState: UseModalState;
  onConfirmClockOut: () => void;
  onCancel?: () => void;
  shiftId: string;
  workplaceId: string;
}

export function ClockOutChartingReminder({
  modalState,
  onConfirmClockOut,
  onCancel,
  shiftId,
  workplaceId,
}: ClockOutChartingReminderProps) {
  const [isChecked, setIsChecked] = useState(false);

  const logMetadata = {
    timestamp: new Date().toISOString(),
    shiftId,
    workplaceId,
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet canDismiss={false} modalState={modalState}>
        <Box sx={{ paddingX: 4, paddingTop: 8, display: "flex", flexDirection: "column", gap: 3 }}>
          <Text bold variant="h4" sx={{ textAlign: "center" }}>
            Ready to clock out? Have you completed 100% of your charting tasks?
          </Text>

          <Box sx={{ marginTop: 6, display: "flex", justifyContent: "center" }}>
            <Illustration type="quiz-required" />
          </Box>

          <FormControlLabel
            sx={{
              marginTop: 6,
              marginX: 0,
            }}
            control={
              <Checkbox
                checked={isChecked}
                sx={{ margin: 4 }}
                onChange={(event) => {
                  setIsChecked(event.target.checked);
                }}
              />
            }
            label={
              <Text variant="body1" sx={{ lineHeight: 1.3, userSelect: "none" }}>
                I understand that I can&apos;t book shifts at workplaces requiring charting until I
                complete my charting.
              </Text>
            }
          />
        </Box>
        <DialogFooter orientation="vertical" LinkComponent={Link}>
          <Button
            fullWidth
            size="large"
            disabled={!isChecked}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CHARTING_REMINDER_CLOCK_OUT_CONTINUE, logMetadata);
              onConfirmClockOut();
            }}
          >
            I&apos;m at 100%, continue with clock out
          </Button>

          <Button
            fullWidth
            size="large"
            variant="outlined"
            sx={{ marginTop: 2 }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CHARTING_REMINDER_CLOCK_OUT_CANCEL, logMetadata);
              modalState.closeModal();
              onCancel?.();
            }}
          >
            Not yet, I&apos;ll finish charting
          </Button>
        </DialogFooter>
      </BottomSheet>
    </ThemeProvider>
  );
}
